module.exports = __webpack_public_path__ + "img/Group 884two.bef1ad97.svg";